<template>
    <div>
        <div v-if="!thankYou" class="top-navigation">
            <div class="navigation-item hover-pink" :class="activeSelection === 0 ? 'active-pink' : ''" :style="blackFriday ? {'max-width': '33%'} : {'max-width': '49%'}" @click="activeSelection = 0; stepActive = 0">
                <img src="@/assets/images/sketch_new.png" alt="">
                <p>Comandă o singură licență</p>
            </div>
            <div class="navigation-item hover-green" :class="activeSelection === 1 ? 'active-green' : ''" :style="blackFriday ? {'max-width': '33%'} : {'max-width': '49%'}" @click="activeSelection = 1; stepActive = 0">
                <img src="@/assets/images/M3/M3Sketch/poc-sketch-consultant.png" alt="">
                <p>Comandă mai multe licențe</p>
            </div>
            <div v-if="blackFriday" class="navigation-item hover-black" :class="activeSelection === 1 ? 'active-green' : ''" :style="blackFriday ? {'max-width': '33%'} : {'max-width': '49%'}" @click="activeSelection = 1">
                <img src="@/assets/images/M3/M3Sketch/black-friday.png" alt="">
                <div class="flex space-between align-center" style="width: 100%;">
                    <div>
                        <p><span class="red-text">MAXIM</span> 10 LICENȚE</p>
                        <p style="font-size: 10px;">Exclusiv vineri, 12 noiembrie</p>
                    </div>
                    <p class="price-number"><sub class="red-text">€</sub>199</p>
                </div>
            </div>
        </div>
        <div :class="thankYou ? 'mt-4 after-thank' :'mt-4 informare-wrapper'">
            <LicentaSucces v-if="thankYou" :redirect="redirect" :payment="payment" :paymentMethod="paymentMethod"></LicentaSucces>
            <div v-else class="plata-content">
                <div class="licente white-box">
                    <LicentaUnica v-if="activeSelection === 0" :data="licenseData" :price="price" :discounted="discountedPrice" :statistics="statistics" :licenseModalShowed="licenseModalShowed" @licenseModalShowed="licenseModalShowed = true" @increaseStep="increaseStep($event)" @switchSelection="activeSelection = 1; stepActive = 0"></LicentaUnica>
                    <LicentaConsultant v-if="activeSelection === 1" :data="licenseData" :discount="multipleLicensesDiscount" :statistics="statistics" :licenseModalShowed="licenseModalShowed" @licenseModalShowed="licenseModalShowed = true" @licensesChanged="licensesChanged($event)" @increaseStep="increaseStep($event)" @switchSelection="activeSelection = 0; stepActive = 0"></LicentaConsultant>

                </div>
            </div>
            <div v-if="stepActive === 1" class="facturare white-box">
                <FacturareSingle v-show="activeSelection === 0 && !loading" :planId="planId" :discounted="discountedPrice" @legalRepresentant="legalRepresentant = $event" @metodaFacturare="metodaFacturare = $event" @termsAccepted="termsAccepted = $event" @thankYouPage="complete($event)" @coupons="calculateNewPrice($event)" @redirect="redirect = $event" @loadingStatus="changeLoadingStatus($event)"></FacturareSingle>
                <LoadingSpinner v-show="activeSelection === 0 && loading" style="min-height: 400px;"></LoadingSpinner>
                <FacturareConsultant v-show="activeSelection === 1 && !loading" :licente="licensesNumber" :planId="planId" @legalRepresentant="legalRepresentant = $event" @termsAccepted="termsAccepted = $event" @thankYouPage="complete($event)" @coupons="multipleLicensesDiscount = $event" @redirect="redirect = $event"></FacturareConsultant>
                <LoadingSpinner v-show="activeSelection === 1 && loading" style="min-height: 400px;"></LoadingSpinner>
            </div>
            <div v-if="stepActive === 0 && !thankYou" class="informare-licente">
                <h3 class="informare-title light-gray mt-5 mb-2">Informare</h3>
                <p>Achiziția licenței <b>POC</b>Sketch este un proces ireversibil.</p>
                <p>Indiferent care sunt datele de  facturare alese poți utiliza licența pentru orice companie. Licența de utilizare permite scrierea unui singur proiect. Pentru mai multe companii / proiecte este necesară achiziția unui număr corespunzător de licențe.</p>
                <h3 class="informare-title light-gray mt-5 mb-2">În atenția consultanților</h3>
                <p>Dacă reprezinți o companie de consultanță îți recomandăm achiziția numărului total de licențe necesare la momentul primei comenzi. De exemplu, dacă dorești să achiziționezi 15 licențe în total, te rugăm să faci acest lucru odată cu prima comandă pentru a beneficia de reducerile pentru volume mari. Dacă vei achiziționa cele 15 licențe în 3 comenzi separate, de exemplu 10 licențe + 4 licențe + 1 licență, vei achita un cost diferit/licență la fiecare comandă.</p>
                <h3 class="informare-title light-gray mt-5 mb-2">Garanția noastră</h3>
                <p>Echipa noastră îți garantează achiziția. Astfel, în cazuri excepționale precum <b>anularea măsurii</b>  licența va rămâne activă pentru aceeaşi finanțare sau o aplicație similară. Vei avea acces la o aplicație de scriere proiecte actualizată în baza modificărilor apărute.</p>
            </div>
        </div>
        <v-tour name="pfTour" :steps="stepsPf" :options="tourOptions"></v-tour>
        <v-tour name="consultantTour" :steps="stepsCons" :options="tourOptions2"></v-tour>
    </div>
</template>

<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import LicentaUnica from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/LicentaUnica'
    import LicentaConsultant from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/LicentaConsultant'
    import LicentaSucces from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/LicentaSucces'
    import FacturareSingle from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/FacturareSingle'
    import FacturareConsultant from '@/pages/Aplicatii/M3/M3Sketch/components/cumpara-licenta/FacturareConsultant'
    import moment from 'moment'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    import Vue from 'vue'
    import VueTour from 'vue-tour'
    Vue.use(VueTour)
    require('vue-tour/dist/vue-tour.css')

    export default {
        components: {
            LoadingSpinner,
            LicentaUnica,
            LicentaConsultant,
            LicentaSucces,
            FacturareSingle,
            FacturareConsultant,
            VueTour
        },
        props: {
            licenseData: null,
            tutorialStarted: null,
        },
        data() {
            return {
                activeSelection: 0,
                stepActive: 0,
                blackFriday: false,
                licensesNumber: 0,
                thankYou: false,
                redirect: [],
                payment: {},
                paymentMethod: '',
                planId: null,
                price: null,
                loading: false,
                discountedPrice: null,
                multipleLicensesDiscount: 0,
                legalRepresentant: null,
                metodaFacturare: null,
                termsAccepted: null,
                licenseModalShowed: false,
                stepsPf: [
                    {
                        target: '#v-step-0',
                        header: {
                            title: 'Costul total',
                        },
                        content: `Acesta este costul tău total.`,
                        params: {
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-1',
                        header: {
                            title: 'Facturarea',
                        },
                        content: 'Folosește acest buton pentru a continua către facturare.',
                        params: {
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-2',
                        header: {
                            title: 'Metoda de facturare',
                        },
                        content: `Alege folosind următoarele butoane, firma pe care dorești să facturezi licența.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.stepActive === 1 && !this.loading) {
                                resolve('')
                            } else {
                                this.$toast.error('Apasă pe "Continuă către facturare" pentru a avansa.')
                            }
                        })
                    },
                    {
                        target: '#v-step-3',
                        header: {
                            title: 'Reprezentantul legal',
                        },
                        content: `Asigură-te că acest câmp este completat!`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.metodaFacturare === 'A' || this.metodaFacturare === 'B') {
                                resolve('')
                            } else {
                                this.$toast.error('Completează câmpul "Metoda de facturare".')
                            }
                        })
                    },
                    {
                        target: '#v-step-4',
                        header: {
                            title: 'Metoda de plată',
                        },
                        content: `Alege metoda de plată folosind următoarele butoane.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.legalRepresentant && this.legalRepresentant.length > 0) {
                                resolve('')
                            } else {
                                this.$toast.error('Completează câmpul "Reprezentant legal".')
                            }
                        })
                    },
                    {
                        target: '#v-step-5',
                        header: {
                            title: 'Termeni și condiții',
                        },
                        content: `Citește termenii și condițiile și politicile noastre și confirmă că ești de acord cu acestea.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-6',
                        header: {
                            title: 'Finalizează comanda',
                        },
                        content: `Un singur buton te mai desparte acum de licența POCSketch :)`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.termsAccepted) {
                                resolve('')
                            } else {
                                this.$toast.error('Acceptă câmpul "Termeni și condiții".')
                            }
                        })
                    },
                ],
                stepsCons: [
                    {
                        target: '#v-step-0',
                        header: {
                            title: 'Numărul de licențe',
                        },
                        content: `Completează aici numărul de licențe pe care dorești să îl achiziționezi.`,
                        params: {
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-1',
                        header: {
                            title: 'Cost total',
                        },
                        content: `Acesta este costul tău total.`,
                        params: {
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.licensesNumber && Number(this.licensesNumber) >= 2) {
                                resolve('')
                            } else {
                                this.$toast.error('Completează cu numărul de licențe.')
                            }
                        })
                    },
                    {
                        target: '#v-steps-2',
                        header: {
                            title: 'Metoda de facturare',
                        },
                        content: `Folosește primul buton dacă ai o solicitare particulară sau al doilea dacă dorești să introduci CUI-ul companiei de facturare.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-steps-3',
                        header: {
                            title: 'Reprezentantul legal',
                        },
                        content: `Asigură-te că acest câmp este completat!`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-steps-4',
                        header: {
                            title: 'Metoda de plată',
                        },
                        content: `Alege metoda de plată folosind următoarele butoane.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.legalRepresentant && this.legalRepresentant.length > 0) {
                                resolve('')
                            } else {
                                this.$toast.error('Completează câmpul "Reprezentant legal".')
                            }
                        })
                    },
                    {
                        target: '#v-steps-5',
                        header: {
                            title: 'Termeni și condiții',
                        },
                        content: `Citește termenii și condițiile și politicile noastre și confirmă că ești de acord cu acestea.`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-steps-6',
                        header: {
                            title: 'Finalizează comanda',
                        },
                        content: `Un singur buton te mai desparte acum de licența POCSketch :)`,
                        params: {
                            placement: 'left',
                            enableScrolling: false
                        },
                        before:() => new Promise((resolve) => {
                            if(this.termsAccepted) {
                                resolve('')
                            } else {
                                this.$toast.error('Acceptă câmpul "Termeni și condiții".')
                            }
                        })
                    },
                ],
                tourOptions: {
                    labels: {
                        buttonSkip: 'Închide',
                        buttonPrevious: 'Înapoi',
                        buttonNext: 'Mai departe',
                        buttonStop: 'Finalizează'
                    }
                },
                tourOptions2: {
                    labels: {
                        buttonSkip: 'Închide',
                        buttonPrevious: 'Înapoi',
                        buttonNext: 'Mai departe',
                        buttonStop: 'Finalizează'
                    }
                },
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
        },
        watch: {
            tutorialStarted: {
                handler: function() {
                    if(this.tutorialStarted === 'pf') {
                        this.activeSelection = 0
                        setTimeout(() => {
                            this.$tours['pfTour'].start()
                        }, 450)
                        this.$emit('tourClose')
                    } else if(this.tutorialStarted === 'consultant') {
                        this.activeSelection = 1
                        setTimeout(() => {
                            this.$tours['consultantTour'].start()
                        }, 450)

                        this.$emit('tourClose')
                    }
                },
                deep: true
            }
        },
        mounted() {
            // if(!this.$route.fullPath.includes('orderId')){
            //     this.underConstruction()
            // }
            this.getPlanBySlug('poc-sketch')
            this.getPayment()
            let blackFridayDate = new Date('2021-11-12');
            let result = moment(blackFridayDate).isSame(moment(), "day")
            if(result){
                this.blackFriday = true
            }

        },
        methods: {
            // underConstruction() {
            //     this.$swal({
            //         heightAuto: false,
            //         title: 'Salutare!<br><br>' +
            //             '<p style="font-size: 14px !important;">Îți mulțumim frumos pentru intenția de a achiziționa o licență.</p>' +
            //             '<p style="font-size: 14px !important;">Momentan îți recomandăm să așteptăm împreună lansarea ghidului final. Îmbunătățim aplicația în timp real fără a o închide, astfel există posibilitatea să apară mici erori. Dacă te confrunți cu o problemă de natură tehnică (exemplu: limitări ale contului) te rugăm să ne contactezi la <a href="mailto:office@smis.ro" style="color: #55525c !important;" target="_blank">office@smis.ro</a> sau la <a href="tel:0722114395" style="color: #55525c !important;">0722.114.395</a> / <a href="tel:0722115792" style="color: #55525c !important;">0722.115.792</a>.</p><br>' +
            //             '<p style="font-size: 14px !important; text-align: right;">Îți mulțumim! Cu drag, <em>super-echipa Smis®</em></p>',
            //         icon: 'info',
            //         confirmButtonText: 'Închide'
            //
            //     })
            // },
            calculateNewPrice(discount){
                this.discountedPrice = Number(this.getPriceActive()) - Number(discount) < 0 ? 0 : Number(this.getPriceActive()) - Number(discount);
            },
            increaseStep(event){
                this.licensesNumber = event
                this.stepActive = 1
            },
            licensesChanged(event){
                this.licensesNumber = event
                this.stepActive = 0
            },
            changeLoadingStatus(event){
                this.loading = event
            },
            getPayment() {
                if (! this.$route.query.orderId) {
                    return;
                }

                this.thankYou = true
                return axios.get(api.API_ENDPOINTS.payments + '/complete', {
                    params: {
                        orderId: this.$route.query.orderId
                    }
                }).then((response) => {
                    this.payment = response.data
                    this.paymentMethod = response.data.payment_method;
                    if(response.data.status.type == 'success') {
                        this.$toast.success(response.data.status.message);
                    } else {
                        this.$toast.error(response.data.status.message);
                    }
                })
            },

            getPlanBySlug(slug) {
                if (! slug) {
                    return;
                }

                return axios.get(api.API_ENDPOINTS.fetchApps + '/' + slug)
                    .then((response) => {
                        this.$store.dispatch('pageLoading/setLoading', false)
                        this.planId = response.data.id
                        this.price = response.data.price
                    })
            },

            complete(method) {
                this.paymentMethod = method;
                this.thankYou = true
                this.$emit('getLicenseData')
            },

            getPriceActive() {
                if(this.licenseData.m2manager) {
                    return 950
                } else if(this.licenseData.utm_source === 'termene') {
                    return 1400
                } else {
                    return this.price
                }
            }
        }
    }
</script>

<style scoped>
.informare-wrapper >>> .b-overlay-wrap{
    margin: -20px;
    padding: 20px;
}

.after-thank .facturare.white-box{
    display: none;
}
.informare-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2rem;
}
.informare-licente {
    text-align: center;
    max-width: 100%;
    width: 100%;
    background: #fff;
    padding: 20px;
}
.informare-licente h3 {
    font-size: 22px;
    font-weight: bold;
    color: #b6bfc7;
}
.informare-licente p{
    text-align: center;
    padding-bottom: 15px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
    height: fit-content;
}
.top-navigation{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.navigation-item{
    background: linear-gradient(to bottom, #5a5a5a, #686868);
    padding: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 49%;
    transition: 0.4s;
    cursor: pointer;
    height: 47px;
}
.navigation-item p{
    font-size: 14px;
    font-weight: 600;
    color: #fff;
}
.navigation-item img{
    margin-right: 20px;
    max-height: 36px;
}
.navigation-item:first-child img{
    filter: brightness(0) invert(1);
}
.hover-pink:hover{
    background: linear-gradient(to bottom, #e6ad8a, #a669af);
    transition: 0.4s;
}
.hover-green:hover{
    background: linear-gradient(to bottom, #03c990, #029db4);
    transition: 0.4s;
}
.hover-black{
    background: #000000;
}
.active-pink{
    background: linear-gradient(to bottom, #e6ad8a, #a669af);
}
.active-green{
    background: linear-gradient(to bottom, #03c990, #029db4);
}
.plata-content{
    display: flex;
    justify-content: space-between;
    width: 100%;
	height: 100%;
}
.licente, .facturare{
    width: 100%;
    max-width: 100%;

}
.facturare{
    min-height: 517px;
}
.red-text{
    color: #be2d37;
}
.hover-black p{
    font-weight: 700;
}
.price-number{
    font-size: 24px !important;
}
.price-number sub{
    bottom: 0;
    font-size: 16px;
}
@media (max-width: 1600px) {
    .plata-content{
        max-width: 605px;
    }
    >>> .price h3{
        font-size: 50px;
    }
    >>> .price-active h3{
        font-size: 45px;
    }
    >>> .border-section {
        padding: 25px 10px;
    }
    .licente, .facturare{
        height: 100%;
    }
}
</style>
